import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const Goal = ({ style })=>{
    return /*#__PURE__*/ _jsx("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: style.fontSize,
            height: style.fontSize
        },
        children: /*#__PURE__*/ _jsxs("svg", {
            height: style.fontSize,
            width: style.fontSize,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: "goal-65"
                }),
                /*#__PURE__*/ _jsxs("g", {
                    strokeWidth: "1",
                    fill: "#ffffff",
                    stroke: "#ffffff",
                    children: [
                        /*#__PURE__*/ _jsx("path", {
                            d: "M4,11.125A5.5,5.5,0,1,1,11.125,4",
                            fill: "none",
                            stroke: "#ffffff",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        " ",
                        /*#__PURE__*/ _jsx("polygon", {
                            points: "5.5 5.5 14.5 6.5 11.5 9.5 15.5 13.5 13.5 15.5 9.5 11.5 6.5 14.5 5.5 5.5",
                            fill: "none",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            "data-color": "color-2"
                        })
                    ]
                })
            ]
        })
    });
};
export default Goal;
